export const FETCH_MENU_DETAILS_REQUEST = 'FETCH_MENU_DETAILS_REQUEST';
export const FETCH_MENU_DETAILS_SUCCESS = 'FETCH_MENU_DETAILS_SUCCESS';
export const FETCH_MENU_DETAILS_FAILURE = 'FETCH_MENU_DETAILS_FAILURE';